'use client';

import React from 'react';

import loadingImage from '@/public/images/loading.gif';
import Image from 'next/image';

import classes from './loading.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

function Loading() {
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);

  return (
    <div
      className={classes.loadingWrap}
      style={{ display: isLoading ? 'display' : 'none' }}
    >
      <Image src={loadingImage} alt="loading" width={50} height={50} />
    </div>
  );
}

export default Loading;
